module.exports = {"api":{"endpoint":"http://localhost:3100"}};